var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AMBULANCE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.009,27.348V17.74a2,2,0,0,0-2-2H63.818a2,2,0,0,0-2,2v9.608Z",
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.693,98.557V66.008A15.017,15.017,0,0,0,120.5,60.14L108.111,31a6,6,0,0,0-5.521-3.653H11.307a5,5,0,0,0-5,5V98.557Z",
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.346 45.338 44.48 45.338 44.48 36.471 35.836 36.471 35.836 45.338 26.969 45.338 26.969 53.981 35.836 53.981 35.836 62.848 44.48 62.848 44.48 53.981 53.346 53.981 53.346 45.338",
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,62.95H74.01V36.37H110.4l10.1,23.77A14.051,14.051,0,0,1,121.37,62.95Z",
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.307,
    y: 73.903,
    width: 115.386,
    height: 24.654,
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.693,83.854l-7.055-1.068a4,4,0,0,1-3.4-3.955V73.9h10.456Z",
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 98.557,
    r: 13.703,
    transform: "translate(-70.817 108.319) rotate(-77.147)",
    fill: "#9b8e99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 98.557,
    r: 13.703,
    transform: "translate(-41.634 103.856) rotate(-48.115)",
    fill: "#9b8e99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03,98.557a5.531,5.531,0,1,1-5.53-5.531A5.53,5.53,0,0,1,38.03,98.557Z",
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.031,98.557A5.531,5.531,0,1,1,95.5,93.026,5.531,5.531,0,0,1,101.031,98.557Z",
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,91.276a7.281,7.281,0,1,0,7.28,7.281A7.289,7.289,0,0,0,32.5,91.276Zm0,11.061a3.781,3.781,0,1,1,3.78-3.78A3.784,3.784,0,0,1,32.5,102.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.22,98.557a7.281,7.281,0,1,0,7.28-7.281A7.289,7.289,0,0,0,88.22,98.557Zm11.061,0A3.781,3.781,0,1,1,95.5,94.776,3.784,3.784,0,0,1,99.281,98.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.426,29.1h4.5a1.75,1.75,0,0,0,0-3.5h-4.5a1.75,1.75,0,0,0,0,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.091,62.6V62.6a16.748,16.748,0,0,0-.982-3.14l-10.1-23.764L112,35.681l-2.28-5.365a7.739,7.739,0,0,0-7.133-4.718H75.759V17.74a3.754,3.754,0,0,0-3.75-3.75H63.818a3.754,3.754,0,0,0-3.75,3.75V25.6H41.581a1.75,1.75,0,0,0,0,3.5h61.008a4.244,4.244,0,0,1,3.912,2.587l1.246,2.932H74.009a1.75,1.75,0,0,0-1.75,1.75V62.953a1.75,1.75,0,0,0,1.75,1.75h45.869c.042.432.065.867.065,1.3v6.145H8.057V32.348a3.254,3.254,0,0,1,3.25-3.25h6.88a1.75,1.75,0,0,0,0-3.5h-6.88a6.758,6.758,0,0,0-6.75,6.75V98.557a1.751,1.751,0,0,0,1.75,1.75H17.153a15.446,15.446,0,0,0,30.694,0H80.153a15.45,15.45,0,0,0,23.556,11.344,1.749,1.749,0,1,0-1.861-2.963,11.939,11.939,0,1,1,4.757-5.7,1.75,1.75,0,1,0,3.25,1.3,15.318,15.318,0,0,0,.99-3.98h10.848a1.751,1.751,0,0,0,1.75-1.75V66.008A16.7,16.7,0,0,0,123.091,62.6ZM63.568,17.74a.25.25,0,0,1,.25-.25h8.191a.251.251,0,0,1,.25.25V25.6H63.568ZM75.759,61.2V38.117h33.476l9.652,22.708c.053.124.09.252.139.378Zm44.184,20.616-5.043-.764a2.237,2.237,0,0,1-1.913-2.224V75.653h6.956ZM32.5,110.51A11.953,11.953,0,1,1,44.453,98.557,11.967,11.967,0,0,1,32.5,110.51Zm78.347-13.7a15.446,15.446,0,0,0-30.694,0H47.847a15.446,15.446,0,0,0-30.694,0h-9.1V75.653h101.43v3.178a5.718,5.718,0,0,0,4.889,5.685l5.567.843V96.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.969,55.731h7.117v7.117a1.75,1.75,0,0,0,1.75,1.75h8.643a1.749,1.749,0,0,0,1.75-1.75V55.731h7.117a1.75,1.75,0,0,0,1.75-1.75V45.338a1.751,1.751,0,0,0-1.75-1.75H46.229V36.471a1.75,1.75,0,0,0-1.75-1.75H35.836a1.751,1.751,0,0,0-1.75,1.75v7.117H26.969a1.751,1.751,0,0,0-1.75,1.75v8.643A1.75,1.75,0,0,0,26.969,55.731Zm1.75-8.643h7.117a1.75,1.75,0,0,0,1.75-1.75V38.221h5.143v7.117a1.751,1.751,0,0,0,1.75,1.75H51.6v5.143H44.479a1.751,1.751,0,0,0-1.75,1.75V61.1H37.586V53.981a1.75,1.75,0,0,0-1.75-1.75H28.719Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/react-icon.09716edf8c69110a1bdd938abf4a31ba.svg";
export { ForwardRef as ReactComponent };